import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import PessoaFisicaService from "./pessoaFisicaService"
import { formatCPF, formatCellphone } from 'helper/formater'
import FormList from 'base/FormList'
import { biggerThan } from 'helper/ui/responsive'

export default function PessoaFisicaList() {

    const [service] = useState(() => new PessoaFisicaService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_pef',
        dsName: 'nome_razao_pes',
        mainField: { name: 'nome_razao_pes', label: 'Nome' },
        advFields: [
            { name: 'nome_razao_pes', label: 'Nome' },
            { name: 'cpf_cnpj_pes', label: 'CPF', inputMode: 'numeric' },
            { name: 'descricao_ende', label: 'Rua' },
            { name: 'tel_cel_pes', label: 'Celular', inputMode: 'tel' },
            { name: 'codigo_pef', label: 'Código', type: 'integer', inputMode: 'numeric' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (

        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>

            <Column field="meta.nome_razao_pes" sortable header="Nome"></Column>
            <Column field="meta.cpf_cnpj_pes" body={e => formatCPF(e.meta.cpf_cnpj_pes)} sortable header="CPF" style={{ display: biggerThan('sm') }}></Column>
            <Column field="meta.tel_cel_pes" body={e => formatCellphone(e.meta.tel_cel_pes)} sortable header="Celular"></Column>

        </FormList >
    )
}
